module.exports = __webpack_public_path__ + "static/media/studentcompetencies.f8b08446.png";